import { render, staticRenderFns } from "./DashedAddResource.vue?vue&type=template&id=8ac8b17c&scoped=true&"
import script from "./DashedAddResource.vue?vue&type=script&lang=js&"
export * from "./DashedAddResource.vue?vue&type=script&lang=js&"
import style0 from "./DashedAddResource.vue?vue&type=style&index=0&id=8ac8b17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac8b17c",
  null
  
)

export default component.exports